import { createGlobalStyle } from 'styled-components';

import resets from './resets';
import resetsMemed from './resets-memed';
import icons from './icons';

export const GlobalStyles = createGlobalStyle`
  ${resets};
  ${resetsMemed};
  ${icons};
`;
